import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmptyState from '../../../../components/EmptyState';
import AlertMessage from '../../../../components/AlertMessage';

import THead from './THead';
import TBody from './TBody';
import Pagination from '../../../../components/Pagination';

import './styles.css';

class AdminTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAllRowsSelected: false,
      selectedRows: [],
      currentPage: 1,
      paginationConfig: {
        pageLimit: 10,
        options: [{
          value: 10,
          label: '10',
        }, {
          value: 25,
          label: '25',
        }, {
          value: 50,
          label: '50',
        }, {
          value: 100,
          label: '100',
        }],
      },
    };
  }

  _selectAllRows = (rowData) => {
    const isAllRowsSelected = !this.state.isAllRowsSelected;
    let selectedRows = [];

    if (isAllRowsSelected) {
      selectedRows = [...rowData];
    }

    this.setState({ selectedRows, isAllRowsSelected });

    const { onRowSelect } = this.props;
    if (onRowSelect) onRowSelect(null, selectedRows);
  }

  _selectRow = (row) => {
    let { selectedRows } = this.state;
    let isAllRowsSelected = false;

    if (row.isSelected) {
      selectedRows = selectedRows.filter(el => el.id !== row.id);
    } else {
      selectedRows.push(row);
    }

    isAllRowsSelected = selectedRows.length === this.props.data.length;
    this.setState({ selectedRows, isAllRowsSelected });

    const { onRowSelect } = this.props;
    if (onRowSelect) onRowSelect(row, selectedRows);
  }

  _editRow = (row) => {
    const { onRowEdit } = this.props;
    if (onRowEdit) onRowEdit(row);
  }

  _changePageLimit = (pageLimit) => {
    this.setState({
      currentPage: 1,
      paginationConfig: {
        ...this.state.paginationConfig,
        pageLimit,
      },
    });
  }

  _changePage = (page) => {
    const currentPage = page;
    this.setState({ currentPage });
  }

  _getCurrentPageRows = () => {
    const { data } = this.props;
    const { currentPage } = this.state;
    const { pageLimit } = this.state.paginationConfig;
    const startingIndex = (currentPage - 1) * pageLimit;

    return [...data].splice(startingIndex, pageLimit);
  }

  _isRowSelected = (row) => this.state.selectedRows.find(el => el.id === row.id) ? true : false

  _getRowData = () => {
    const rows = this._getCurrentPageRows();
    return rows.map((row) => {
      return {
        ...row,
        isSelected: this._isRowSelected(row),
      };
    });
  }

  render() {
    const {
      headers,
      data,
      actions,
      errorMessage,
      renderBatchEdit,
      onRenderCell,
    } = this.props;

    const {
      isAllRowsSelected,
      selectedRows,
      paginationConfig,
      currentPage,
    } = this.state;

    const rowData = this._getRowData();

    if (errorMessage) {
      return (
        <AlertMessage
          error
          box
          className="AdminTable__error"
          message={errorMessage}
        />
      );
    }

    if (data[0]) {
      return (
        <div className="AdminTable">
          <table className="AdminTable__table">
            <THead
              headerData={headers}
              actions={actions}
              isAllRowSelected={isAllRowsSelected}
              onSelectAllRows={() => this._selectAllRows(rowData)}
            />
            <TBody
              rowData={rowData}
              actions={actions}
              columnData={headers}
              renderCell={onRenderCell}
              onRowSelect={this._selectRow}
            />
          </table>
          <Pagination
            options={paginationConfig.options}
            currentPage={currentPage}
            totalItems={data.length}
            pageLimit={paginationConfig.pageLimit}
            onPageLimitChange={this._changePageLimit}
            onChangePage={this._changePage}
          />
          {
            selectedRows && selectedRows.length > 1 &&
            renderBatchEdit(selectedRows)
          }
        </div>
      );
    }

    return (
      <EmptyState
        className="AdminTable__empty-state"
        message="Não existem dados para a busca realizada."
      />
    );
  }
}

AdminTable.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  errorMessage: PropTypes.string,
  renderBatchEdit: PropTypes.func,
  onRenderCell: PropTypes.func,
};

export default AdminTable;
